<!-- Modal (Análise Sintética) -->

<ng-template #analiseSintetica let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-analise-sintetica"><b>Análise Sintética</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="d-flex quadro_estatistica justify-content-center">
      <div class="flex-grow-1">
        <div class="d-flex flex-wrap align-content-start justify-content-center">
          <!-- Meta do Dia -->

          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <i class="fa fa-dollar quadros_numeros_icones"></i>
              </div>

              <div class="quadros_numeros_textos">
                {{ valorMetaDia | currency: 'BRL' }}<br />Meta do Dia
              </div>
            </div>
          </div>

          <!-- Vendas do Dia -->

          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <i class="fa fa-dollar quadros_numeros_icones"></i>
              </div>

              <div class="quadros_numeros_textos">
                {{ valorVendasDia | currency: 'BRL' }}<br />Vendas do Dia
              </div>

              <div class="quadros_numeros_porcentagem">
                {{ porcentagemVendasDia | currency: 'BRL' : '' }}%
              </div>
            </div>
          </div>

          <!-- Vendas do Mês -->

          <div class="quadros_numeros_lg p-2">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2">
                <i class="fa fa-dollar quadros_numeros_icones"></i>
              </div>

              <div class="quadros_numeros_textos">
                {{ valorVendasMes | currency: 'BRL' }}<br />Vendas do Mês
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th>Período</th>
            <th class="text-center tabela_borda">Qtde Ligações</th>
            <th class="text-center tabela_borda">Qtde Vendas</th>
            <th class="text-right">%</th>
            <th class="text-center tabela_borda">Qtde Lig. s/ Venda</th>
            <th class="text-right">%</th>
            <th class="text-center tabela_borda">Qtde Lig. Feitas</th>
            <th class="text-right">%</th>
            <th class="text-center tabela_borda">Qtde Lig. Recebidas</th>
            <th class="text-right">%</th>
            <th class="text-center tabela_borda">Qtde Outros</th>
            <th class="text-right">%</th>
          </tr>
        </thead>

        <tbody>
          @for (ligacaoSintetica of ligacoesSinteticas; track ligacaoSintetica) {
            <tr>
              <td>{{ ligacaoSintetica.periodo }}</td>
              <td class="text-center tabela_borda">{{ ligacaoSintetica.qtdeligacoes }}</td>
              <td class="text-center tabela_borda">{{ ligacaoSintetica.qtdevenda }}</td>
              <td class="text-right">{{ ligacaoSintetica.porcentagemvenda | currency: 'BRL' : '' }}%</td>
              <td class="text-center tabela_borda">{{ ligacaoSintetica.qtdeligacoessemvenda }}</td>
              <td class="text-right">{{ ligacaoSintetica.porcentagemligacoessemvenda | currency: 'BRL' : '' }}%</td>
              <td class="text-center tabela_borda">{{ ligacaoSintetica.qtdeligacoesfeitas }}</td>
              <td class="text-right">{{ ligacaoSintetica.porcentagemligacoesfeitas | currency: 'BRL' : '' }}%</td>
              <td class="text-center tabela_borda">{{ ligacaoSintetica.qtdeligacoesrecebidas }}</td>
              <td class="text-right">{{ ligacaoSintetica.porcentagemligacoesrecebidas | currency: 'BRL' : '' }}%</td>
              <td class="text-center tabela_borda">{{ ligacaoSintetica.qtdeoutros }}</td>
              <td class="text-right">{{ ligacaoSintetica.porcentagemoutros | currency: 'BRL' : '' }}%</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Geração de Ligações do Dia) -->

<ng-template #geracaoLigacoesDiaResumo let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title"><b>Ligações geradas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="alert alert-success mb-3">
      {{ geracaoLigacoesDiaResumoDados?.mensagem || 'Ligações geradas com sucesso.' }}
    </div>

    <div class="d-flex flex-wrap align-items-center mb-3">
      <div class="quadros_numeros_lg p-2">
        <div class="d-flex align-items-center">
          <div class="pl-2 pr-2">
            <i class="fa fa-phone quadros_numeros_icones"></i>
          </div>

          <div class="quadros_numeros_textos">
            {{ geracaoLigacoesDiaResumoDados?.total_gerado || 0 }}<br />Ligações geradas
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap align-items-center mb-3">
      <div class="quadros_numeros_lg p-2">
        <div class="quadros_numeros_textos">
          {{ geracaoLigacoesDiaResumoDados?.total_gerado_normal || 0 }}<br />Regra normal
        </div>
      </div>

      <div class="quadros_numeros_lg p-2 ml-2">
        <div class="quadros_numeros_textos">
          {{ geracaoLigacoesDiaResumoDados?.total_gerado_completar || 0 }}<br />Completar
        </div>
      </div>
    </div>

    <div class="alert alert-info mb-3">
      <div><b>Regra normal:</b> {{ geracaoLigacoesDiaResumoDados?.regra_normal || '-' }}</div>
      <div><b>Regra completar:</b> {{ geracaoLigacoesDiaResumoDados?.regra_completar || '-' }}</div>
    </div>

    <h5><b>Geracao normal</b></h5>

    <div class="row">
      <div class="col-md-6">
        <h5><b>Por vendedor</b></h5>

        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Vendedor</th>
                <th class="text-right">Qtde</th>
              </tr>
            </thead>

            <tbody>
              @for (item of (geracaoLigacoesDiaResumoDados?.por_vendedor_normal || []); track item) {
                <tr>
                  <td>{{ item.descricao }}</td>
                  <td class="text-right">{{ item.quantidade }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-md-6">
        <h5><b>Por relacionamento</b></h5>

        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Relacionamento</th>
                <th class="text-right">Qtde</th>
              </tr>
            </thead>

            <tbody>
              @for (item of (geracaoLigacoesDiaResumoDados?.por_relacionamento_normal || []); track item) {
                <tr>
                  <td>{{ item.descricao }}</td>
                  <td class="text-right">{{ item.quantidade }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

    @if ((geracaoLigacoesDiaResumoDados?.total_gerado_completar || 0) > 0) {
      <hr />

      <h5><b>Geracao completar</b></h5>

      <div class="row">
        <div class="col-md-6">
          <h5><b>Por vendedor</b></h5>

          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Vendedor</th>
                  <th class="text-right">Qtde</th>
                </tr>
              </thead>

              <tbody>
                @for (item of (geracaoLigacoesDiaResumoDados?.por_vendedor_completar || []); track item) {
                  <tr>
                    <td>{{ item.descricao }}</td>
                    <td class="text-right">{{ item.quantidade }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-md-6">
          <h5><b>Por relacionamento</b></h5>

          <div class="table-responsive">
            <table class="table table-sm table-hover">
              <thead>
                <tr>
                  <th>Relacionamento</th>
                  <th class="text-right">Qtde</th>
                </tr>
              </thead>

              <tbody>
                @for (item of (geracaoLigacoesDiaResumoDados?.por_relacionamento_completar || []); track item) {
                  <tr>
                    <td>{{ item.descricao }}</td>
                    <td class="text-right">{{ item.quantidade }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }

    @if ((geracaoLigacoesDiaResumoDados?.avisos || []).length > 0) {
      <div class="alert alert-warning mt-3 mb-0">
        @for (aviso of geracaoLigacoesDiaResumoDados?.avisos; track aviso) {
          <div>{{ aviso }}</div>
        }
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Fechar</button>
  </div>
</ng-template>

<!-- Modal (Ligação (Mensagem)) -->

<ng-template #ligacaoMensagem let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-ligacao-mensagem"><b>Ligação (Mensagem)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group col-sm-12">
      <label><b>Mensagem:</b></label>

      <textarea class="form-control form-control-sm" rows="1" name="ligacaoAnaliticaMensagem" [value]="ligacaoAnaliticaMensagem" disabled></textarea>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (CRM LigaÃ§Ãµes - CalendÃ¡rio) -->

<ng-template #crmCalendarioFuturas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title"><b>{{ crmCalendarioModalTitulo() }}</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="crm-calendar-toolbar">
      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="crmCalendarioMesAnterior()">
        <i class="fa fa-chevron-left"></i>
      </button>

      <div class="crm-calendar-title">{{ crmCalendarioTitulo() }}</div>

      <button class="btn btn-outline-secondary btn-sm" type="button" (click)="crmCalendarioMesProximo()">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <div class="crm-calendar-edit">
      <div>
        <span>Selecao</span>
        <b>{{ crmCalendarioResumoSelecao() }}</b>
      </div>

      <label>
        <span>Vend interna</span>
        <select class="form-control" [(ngModel)]="crmCalendarioFiltroVendInterna" (change)="alterarFiltroVendInternaCrmCalendario()">
          <option value="">Todas</option>
          @for (vendInterna of crmVendedorasInternasFiltro; track vendInterna) {
            <option [value]="vendInterna">{{ vendInterna }}</option>
          }
        </select>
      </label>

      <label>
        <span>Nova data</span>
        <input class="form-control" type="date" [(ngModel)]="crmCalendarioNovaData" />
      </label>

      <button class="btn btn-success" type="button" [disabled]="crmCalendarioLigacoesSelecionadasIds.length == 0" (click)="salvarCrmCalendarioLigacoesData()">Salvar data</button>

      @if (podeVisualizarCrmCalendarioGeral) {
        <button class="btn btn-outline-danger" type="button" [disabled]="crmCalendarioLigacoesSelecionadasIds.length == 0" (click)="inativarCrmLigacoesSelecionadas()">Inativar selecionadas</button>
      }

      <button class="btn btn-outline-secondary" type="button" [disabled]="crmCalendarioLigacoesSelecionadasIds.length == 0" (click)="limparSelecaoCrmCalendario()">Limpar selecao</button>
    </div>

    <div class="crm-calendar-week">
      @for (diaSemana of crmCalendarioSemana; track diaSemana) {
        <div>{{ diaSemana }}</div>
      }
    </div>

    <div class="crm-calendar-grid">
      @for (dia of crmCalendarioDias; track $index) {
        <div class="crm-calendar-day" [class.crm-calendar-day-empty]="dia.dia == null">
          @if (dia.dia != null) {
            <div class="crm-calendar-day-header">
              <div class="crm-calendar-day-number">{{ dia.dia }}</div>

              @if (crmCalendarioDiaTemLigacoes(dia)) {
                <label class="crm-calendar-select-day" title="Selecionar todas as ligacoes do dia">
                  <input type="checkbox" [checked]="crmCalendarioDiaTodosSelecionados(dia)" (change)="selecionarTodasCrmCalendarioDia(dia, $event)" />
                  <span>Todas</span>
                </label>
              }
            </div>

            @for (ligacao of dia.ligacoes; track ligacao.id) {
              <div class="crm-calendar-call-row" [class.crm-calendar-call-row-selected]="crmCalendarioLigacaoMarcada(ligacao)">
                <input class="crm-calendar-check" type="checkbox" [checked]="crmCalendarioLigacaoMarcada(ligacao)" (change)="selecionarCrmLigacaoCalendario(ligacao)" />
                <button class="crm-calendar-call" type="button" (click)="selecionarCrmLigacaoCalendario(ligacao)">
                  {{ ligacao.name }}
                </button>
                @if (podeVisualizarCrmCalendarioGeral) {
                  <button class="crm-calendar-inativar" type="button" title="Inativar ligacao" (click)="inativarCrmLigacao(ligacao, modal)">
                    <i class="fa fa-times"></i>
                  </button>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Ok')">Fechar</button>
  </div>
</ng-template>

<!-- Modal (CRM Ligações - Inativar atrasadas em massa) -->

<ng-template #crmInativarAtrasadasMassa let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title"><b>Inativar ligações atrasadas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <label class="w-100">
      <span class="crm-modal-label">Vendedora interna</span>
      <select class="form-control" [(ngModel)]="crmInativacaoMassaVendInterna">
        <option value="">Selecione</option>
        @for (vendinterna of crmVendedorasInternasAtrasadas(); track vendinterna) {
          <option [value]="vendinterna">{{ vendinterna }} - {{ qtdeCrmAtrasadasVendInterna(vendinterna) }} atrasada(s)</option>
        }
      </select>
    </label>

    <div class="alert alert-warning mt-3 mb-0">
      Esta ação marca como inativas todas as ligações atrasadas da vendedora interna selecionada.
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.dismiss('Fechar')">Cancelar</button>
    <button class="btn btn-danger btn_formulario" type="button" (click)="inativarCrmAtrasadasVendInterna(modal)">Inativar</button>
  </div>
</ng-template>

<!-- Modal (Tags (Clientes)) -->

<ng-template #tagsClientes let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-tags-clientes"><b>Tags (Clientes)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Cliente:</b></label>

        <input class="form-control form-control-sm" type="text" name="cliente_tag" [value]="tagClienteNomeSelecionado" disabled />
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="form-row mb-2">
      <div class="form-group col-sm-12">
        <label><b>Tags:</b></label>

        <input type="text" class="form-control" [(ngModel)]="tagCliente">
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<!-- Filtro -->

<ng-template #formularioFiltrar let-filtrar="filtrar">
  <!-- Filtro -->

  <form [formGroup]="formFiltro" (ngSubmit)="filtrar()">
    <div class="form-row">
      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Filtrar por:</b></label>

        <select class="form-control form-control-sm" name="filtrar_por" formControlName="filtro" (change)="alterarFiltro($event.target.value)">
          <!-- 0 = Classificação / 8 = Realizado Ano / 9 = Realizado Mês -->

          @for (opcao of filtroOpcoes; track opcao) {
            <option [value]="opcao.valor" [selected]="opcao.valor == ff.filtro.value" [hidden]="(modelo_tela_ligacoes == 0 && (opcao.valor == 8 || opcao.valor == 9)) || (modelo_tela_ligacoes == 1 && opcao.valor == 0)">{{ opcao.texto }}</option>
          }
        </select>
      </div>

      <!-- Cidade -->

      @if (ff.filtro.value == 0) {
        <div class="form-group col-sm-4">
          <label class="text-secondary"><b>Cidade:</b></label>
          <input class="form-control form-control-sm" type="text" name="filtrar_cidade" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && (ff.cidade.errors?.required || ff.cidade.errors?.minlength) }" formControlName="cidade" />
          @if (enviado && !filtradoVendedor && ff.cidade.errors?.required) {
            <div class="erro pt-1">Cidade em branco!</div>
          }
          @if (enviado && !filtradoVendedor && ff.cidade.errors?.minlength) {
            <div class="erro pt-1">Mínimo de 3 caracteres!</div>
          }
        </div>
      }

      <!-- Classificação -->

      @if (ff.filtro.value == 1) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Classificação:</b></label>
          <select class="form-control form-control-sm" name="filtrar_classificacao" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.classificacao.errors?.required }" formControlName="classificacao">
            <option value=""></option>
            @for (opcao of filtroClassificacoes; track opcao) {
              <option [value]="opcao.classificacao" [selected]="opcao.classificacao == ff.classificacao.value">{{ opcao.classificacao }}</option>
            }
          </select>
          @if (enviado && !filtradoVendedor && ff.classificacao.errors?.required) {
            <div class="erro pt-1">Classificação em branco!</div>
          }
        </div>
      }

      <!-- Cliente -->

      @if (ff.filtro.value == 2) {
        <div class="form-group col-sm-4">
          <label class="text-secondary"><b>Cliente:</b></label>
          <input class="form-control form-control-sm" type="text" name="filtrar_cliente" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && !filtradoVendedor && (ff.cliente.errors?.required || ff.cliente.errors?.minlength) }" formControlName="cliente" />
          @if (enviado && !filtradoVendedor && ff.cliente.errors?.required) {
            <div class="erro pt-1">Cliente em branco!</div>
          }
          @if (enviado && !filtradoVendedor && ff.cliente.errors?.minlength) {
            <div class="erro pt-1">Mínimo de 3 caracteres!</div>
          }
        </div>
      }

      <!-- CNPJ/CPF -->

      @if (ff.filtro.value == 3) {
        <div class="form-group col-sm-3">
          <label class="text-secondary"><b>CNPJ/CPF:</b></label>
          <input class="form-control form-control-sm" type="text" maxlength="18" name="filtrar_cnpj_cpf" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.cnpj_cpf.errors?.required }" formControlName="cnpj_cpf" />
          @if (enviado && !filtradoVendedor && ff.cnpj_cpf.errors?.required) {
            <div class="erro pt-1">CNPJ/CPF em branco!</div>
          }
        </div>
      }

      <!-- Código -->

      @if (ff.filtro.value == 4) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Código:</b></label>
          <input class="form-control form-control-sm" type="text" name="filtrar_codigo" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.codigo.errors?.required }" formControlName="codigo" />
          @if (enviado && !filtradoVendedor && ff.codigo.errors?.required) {
            <div class="erro pt-1">Código em branco!</div>
          }
        </div>
      }

      <!-- Dias sem Compra -->

      @if (ff.filtro.value == 5) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro Inicial:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_nro_inicial_sem_compra" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.nro_inicial_sem_compra.errors?.required }" formControlName="nro_inicial_sem_compra" />
          @if (enviado && !filtradoVendedor && ff.nro_inicial_sem_compra.errors?.required) {
            <div class="erro pt-1">Nro Inicial em branco!</div>
          }
        </div>
      }

      @if (ff.filtro.value == 5) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro Final:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_nro_final_sem_compra" formControlName="nro_final_sem_compra" />
        </div>
      }

      <!-- Dias sem Visita -->

      @if (ff.filtro.value == 6) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro Inicial:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_nro_inicial_sem_visita" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.nro_inicial_sem_visita.errors?.required }" formControlName="nro_inicial_sem_visita" />
          @if (enviado && !filtradoVendedor && ff.nro_inicial_sem_visita.errors?.required) {
            <div class="erro pt-1">Nro Inicial em branco!</div>
          }
        </div>
      }

      @if (ff.filtro.value == 6) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Nro Final:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_nro_final_sem_visita" formControlName="nro_final_sem_visita" />
        </div>
      }

      <!-- Produto -->

      @if (ff.filtro.value == 7) {
        <div class="form-group col-sm-4">
          <label class="text-secondary"><b>Produto:</b></label>
          <input class="form-control form-control-sm" type="text" name="filtrar_produto" [value]="produtoSelecionado != null ? produtoSelecionado.name : ''" disabled />
        </div>
      }

      <!-- Realizado Ano -->

      @if (ff.filtro.value == 8) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Valor Inicial:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_valor_inicial_realizado_ano" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.valor_inicial_realizado_ano.errors?.required }" formControlName="valor_inicial_realizado_ano" />
          @if (enviado && !filtradoVendedor && ff.valor_inicial_realizado_ano.errors?.required) {
            <div class="erro pt-1">Valor Inicial em branco!</div>
          }
        </div>
      }

      @if (ff.filtro.value == 8) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Valor Final:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_valor_final_realizado_ano" formControlName="valor_final_realizado_ano" />
        </div>
      }

      <!-- Realizado Mês -->

      @if (ff.filtro.value == 9) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Valor Inicial:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_valor_inicial_realizado_mes" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.valor_inicial_realizado_mes.errors?.required }" formControlName="valor_inicial_realizado_mes" />
          @if (enviado && !filtradoVendedor && ff.valor_inicial_realizado_mes.errors?.required) {
            <div class="erro pt-1">Valor Inicial em branco!</div>
          }
        </div>
      }

      @if (ff.filtro.value == 9) {
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Valor Final:</b></label>
          <input class="form-control form-control-sm" type="number" min="1" step="1" name="filtrar_valor_final_realizado_mes" formControlName="valor_final_realizado_mes" />
        </div>
      }

      <!-- Segmento -->

      @if (ff.filtro.value == 10) {
        <div class="form-group col-sm-4">
          <label class="text-secondary"><b>Segmento:</b></label>
          <input class="form-control form-control-sm" type="text" name="filtrar_segmento" [ngClass]="{ 'is-invalid': enviado && !filtradoVendedor && ff.segmento.errors?.required }" formControlName="segmento" />
          @if (enviado && !filtradoVendedor && ff.segmento.errors?.required) {
            <div class="erro pt-1">Segmento em branco!</div>
          }
        </div>
      }

      <!-- Tags -->

      @if (ff.filtro.value == 11) {
        <div class="form-group col-sm-4">
          <label class="text-secondary"><b>Tags:</b></label>
          <input type="text" class="form-control" [(ngModel)]="tagFiltro" [ngModelOptions]="{ standalone: true }" [ngClass]="{ 'is-invalid' : enviado && !filtradoVendedor && tagFiltroErro }">
          @if (enviado && !filtradoVendedor && tagFiltroErro) {
            <div class="erro pt-1">Tags em branco!</div>
          }
        </div>
      }

      <!-- Vendedor(a) -->

      <div class="form-group col-sm-3">
        <label class="text-secondary"><b>Vendedor(a):</b></label>

        <input class="form-control form-control-sm" type="text" name="filtrar_vendedor" formControlName="vendedor" />
      </div>

      <div class="col-sm-3">
        <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>

        @if (filtrado) {
          <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltro(null)">Cancelar</button>
        }
      </div>
    </div>
  </form>

  <!-- Produto -->

  @if (ff.filtro.value == 7) {
    <!-- Buscar (Produto) -->
    <form [formGroup]="formFiltroProduto" (ngSubmit)="filtrarProduto()">
      <div class="form-row">
        <div class="form-group col-sm-2">
          <label class="text-secondary"><b>Filtrar Produto por:</b></label>
          <select class="form-control form-control-sm" name="filtrar_produto_por" formControlName="filtro" (change)="alterarFiltroProduto($event.target.value)">
            @for (opcao of filtroProdutos; track opcao) {
              <option [value]="opcao.valor" [selected]="opcao.valor == fp.filtro.value">{{ opcao.texto }}</option>
            }
          </select>
        </div>
        <!-- Código -->
        @if (fp.filtro.value == 0) {
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Código:</b></label>
            <input class="form-control form-control-sm" type="text" name="produto_codigo" [ngClass]="{ 'is-invalid': enviadoProduto && fp.codigo.errors?.required }" formControlName="codigo" />
            @if (enviadoProduto && fp.codigo.errors?.required) {
              <div class="erro pt-1">Código em branco!</div>
            }
          </div>
        }
        <!-- Descrição -->
        @if (fp.filtro.value == 1) {
          <div class="form-group col-sm-7">
            <label class="text-secondary"><b>Descrição:</b></label>
            <input class="form-control form-control-sm" type="text" name="produto_descricao" [ngClass]="{ 'is-invalid': enviadoProduto && fp.descricao.errors?.required }" formControlName="descricao" />
            @if (enviadoProduto && fp.descricao.errors?.required) {
              <div class="erro pt-1">Descrição em branco!</div>
            }
          </div>
        }
        <!-- Marca -->
        @if (fp.filtro.value == 2) {
          <div class="form-group col-sm-7">
            <label class="text-secondary"><b>Marca:</b></label>
            <input class="form-control form-control-sm" type="text" name="produto_marca" [ngClass]="{ 'is-invalid': enviadoProduto && fp.marca.errors?.required }" formControlName="marca" />
            @if (enviadoProduto && fp.marca.errors?.required) {
              <div class="erro pt-1">Marca em branco!</div>
            }
          </div>
        }
        <div class="col-sm-3">
          <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
          @if (filtrandoProduto) {
            <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltroProduto(null)">Cancelar</button>
          }
        </div>
      </div>
    </form>
    @if (filtrandoProduto) {
      <div [@esvanecerDesvanecer]="'in'">
        <hr class="mt-2 mb-2" />
        <div class="filtrar_produto p-1">
          <div class="table-responsive">
            <cdk-virtual-scroll-viewport class="filtrar_produto_tabela" [itemSize]="10">
              <table class="table table-sm table-hover">
                <thead>
                  <tr>
                    <th class="text-center">Código</th>
                    <th class="tabela_borda">Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *cdkVirtualFor="let produto of produtos; templateCacheSize: 0;">
                    <tr class="filtrar_produto_acao" (click)="selecionarProdutoFiltrado(produto.id)">
                      <td class="text-center">{{ produto.codigo }}</td>
                      <td class="tabela_borda">{{ produto.name }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    }
  }

  <hr class="mt-2 mb-2" />
</ng-template>

<ng-template #importarCrmLigacoesModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Importar CRM Ligações</h4>
    <button type="button" class="close" aria-label="Close" (click)="fecharImportacaoCrmLigacoes(modal)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-wrap align-items-center mb-3">
      <button class="btn btn-outline-success mr-2 mb-2" type="button" (click)="baixarModeloCrmLigacoes()">
        <i class="fa fa-download"></i> Baixar planilha modelo
      </button>
      @if (crmImportacaoLinhas.length > 0) {
        <span class="badge badge-info mb-2">{{ crmImportacaoLinhas.length }} registro(s) lido(s)</span>
      }
    </div>

    <div class="form-group">
      <label><b>Arquivo Excel</b></label>
      <input class="form-control" type="file" accept=".xlsx,.xls" (change)="selecionarArquivoCrmLigacoes($event)" />
      <small class="text-muted">Colunas obrigatórias: codclierp, data_ligacao, mensagem.</small>
    </div>

    @if (crmImportacaoErros.length > 0) {
      <div class="alert alert-warning">
        Alguns registros precisam de ajuste antes ou depois da importação.
      </div>
      <div class="table-responsive" style="max-height: 260px; overflow: auto;">
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Linha</th>
              <th>COD ERP</th>
              <th>Data</th>
              <th>Cliente</th>
              <th>Erro</th>
            </tr>
          </thead>
          <tbody>
            @for (erro of crmImportacaoErros; track $index) {
              <tr>
                <td>{{ erro.linha }}</td>
                <td>{{ erro.codclierp }}</td>
                <td>{{ erro.data_ligacao }}</td>
                <td>{{ erro.cliente }}</td>
                <td>{{ erro.erro }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="fecharImportacaoCrmLigacoes(modal)" [disabled]="crmImportando">Fechar</button>
    <button type="button" class="btn btn-success" (click)="importarCrmLigacoes(modal)" [disabled]="crmImportando">
      @if (crmImportando) {
        Importando...
      } @else {
        Importar
      }
    </button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="container-fluid p-0">
    <!-- Título -->
    <div class="bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Venda Interna</div>
        </div>
        <div class="call-center-acoes">
          @if (podeVisualizarCrmCalendarioGeral) {
            <button class="btn call-center-calendario-btn" type="button" title="Calendario de ligacoes" (click)="abrirCrmCalendarioGeral(crmCalendarioFuturas)">
              <i class="fa fa-calendar"></i>
            </button>
          }
          <button class="btn btn-secondary call-center-acao-btn" type="button" (click)="novaLigacao(null)">Nova Ligação</button>
          @if (podeImportarCrmLigacoes) {
            <button class="btn btn-outline-success call-center-acao-btn" type="button" (click)="modalImportarCrmLigacoes(importarCrmLigacoesModal)">Importar Excel</button>
          }
          <button class="btn btn-secondary call-center-acao-btn d-none" type="button" (click)="modalAnaliseSintetica(analiseSintetica)">Análise Sintética</button>
          <div class="call-center-atualizar-discador">
            <button class="btn btn-info call-center-acao-btn" type="button" (click)="atualizar()">Atualizar</button>
            <app-call-center-discador [ligacoesAnaliticas]="crmLigacoesHoje" [compacto]="true" [abrirAtendimentoMesmoSemPabx]="true"></app-call-center-discador>
          </div>
        </div>
      </div>
    </div>
    <ul ngbNav #t="ngbNav" class="nav-tabs" (navChange)="alterarAbas($event)" [(activeId)]="tabSelecionada">
      <!-- Atenção -->
      <li class="d-none" [ngbNavItem]="'atencao'">
        <a ngbNavLink>
          <b>Atenção</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            @if (callCenterConfiguracao != null && callCenterConfiguracao.integrado_pabx && usa_pabx) {
              <app-call-center-discador [ligacoesAnaliticas]="ligacoesAnaliticas"></app-call-center-discador>
            }
            <div class="d-flex quadro_estatistica justify-content-center">
              <div class="flex-grow-1">
                <div class="d-flex flex-wrap align-content-start justify-content-center">
                  <!-- Qtde Ligações -->
                  <div class="quadros_numeros_lg p-2">
                    <div class="d-flex align-items-center">
                      <div class="pl-2 pr-2">
                        <i class="fa fa-list-ul quadros_numeros_icones"></i>
                      </div>
                      <div class="quadros_numeros_textos">
                        {{ qtdeLigacoes }}<br />Qtde Ligações
                      </div>
                    </div>
                  </div>
                  <!-- Qtde Realizado -->
                  <div class="quadros_numeros_lg p-2">
                    <div class="d-flex align-items-center">
                      <div class="pl-2 pr-2">
                        <i class="fa fa-phone quadros_numeros_icones"></i>
                      </div>
                      <div class="quadros_numeros_textos">
                        {{ qtdeRealizado }}<br />Qtde Realizado
                      </div>
                      <div class="quadros_numeros_porcentagem">
                        {{ porcentagemQtdeRealizado | currency: 'BRL' : '' }}%
                      </div>
                    </div>
                  </div>
                  <!-- Meta do Dia -->
                  <div class="quadros_numeros_lg p-2">
                    <div class="d-flex align-items-center">
                      <div class="pl-2 pr-2">
                        <i class="fa fa-dollar quadros_numeros_icones"></i>
                      </div>
                      <div class="quadros_numeros_textos">
                        {{ valorMetaDia | currency: 'BRL' }}<br />Meta do Dia
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Gráfico de Status de Chamadas -->
              <div class="grafico_status p-2">
                <div style="display: block;">
                  <canvas baseChart
                    [data]="pieChartData"
                    [type]="pieChartType"
                    [options]="pieChartOptions"
                    [plugins]="pieChartPlugins"
                    height="120">
                  </canvas>
                </div>
              </div>
            </div>
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-column">
              @if (modelo_tela_ligacoes == 0) {
                <!-- Modelo 1 -->
                <!-- Exibição = Card -->
                @if (ligacoesAnaliticas.length > 0 || filtrado) {
                  <div class="pb-2">
                    <ng-container *ngTemplateOutlet="formularioFiltrar; context: { filtrar: filtrar.bind(this) }"></ng-container>
                    <div class="form-row">
                      <div class="form-group col-sm-2">
                        <label class="text-secondary"><b>Ordenar por:</b></label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por" [(ngModel)]="ordernarLigacoesSelecionado" (change)="ordernarLigacoes($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoes; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                      <div class="form-group col-sm-2">
                        <label class="text-secondary">&nbsp;</label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por_ordem" [(ngModel)]="ordernarLigacoesOrdemSelecionado" (change)="ordernarLigacoesOrdem($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoesOrdem; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesOrdemSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                <table class="tabela_card">
                  <tbody>
                    @for (ligacaoAnalitica of ligacoesAnaliticas; track ligacaoAnalitica; let i = $index) {
                      <tr>
                        @if (ligacaoAnalitica.exibir) {
                          <td>
                            <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="{ 'bg_tabela' : ((i % 2) == 0) }">
                              <div class="flex-grow-1">
                                <!-- Cliente -->
                                <div class="tabela_card_item_destaque mb-1">
                                  <div class="d-flex justify-content-between">
                                    <div class="d-flex">
                                      @if (ligacaoAnalitica.status_name != 'Não Comprou' && ligacaoAnalitica.status_name != 'Venda Realizada') {
                                        <i class="fa fa-phone btn_tabela_acao pr-1" placement="right" ngbTooltip="Alterar Ligação" (click)="alterarLigacao(ligacaoAnalitica.id)"></i>
                                      }
                                      @if (ligacaoAnalitica.mensagem != null && ligacaoAnalitica.mensagem != '') {
                                        <i class="fa fa-info btn_tabela_acao pr-1" placement="right" ngbTooltip="Mensagem" (click)="modalLigacaoMensagem(ligacaoMensagem, ligacaoAnalitica.mensagem)"></i>
                                      }
                                      <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'ligacoes', ligacaoAnalitica.client_id)"></i>
                                      <div>
                                        {{ ligacaoAnalitica.name }}
                                      </div>
                                    </div>
                                    <div class="d-flex">
                                      <div>
                                        {{ ligacaoAnalitica.cidade }}
                                      </div>
                                      @if (ligacaoAnalitica.estado != null) {
                                        <div>
                                          &nbsp;- {{ ligacaoAnalitica.estado }}
                                        </div>
                                      }
                                      @if (ligacaoAnalitica.client_document != null) {
                                        <div>
                                          &nbsp;- {{ ligacaoAnalitica.client_document }}
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex">
                                  <div class="flex-grow-1">
                                    <div class="d-flex flex-column">
                                      <!-- Bagdes -->
                                      <div class="d-flex mb-1">
                                        <div class="tabela_card_item_badge pr-1">
                                          @if (ligacaoAnalitica.status_name == 'ì Ligar') {
                                            <span class="badge badge-primary">ì Ligar</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Agendada') {
                                            <span class="badge badge-warning">Agendada</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Não Comprou') {
                                            <span class="badge badge-danger">Não Comprou</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Sem Contato') {
                                            <span class="badge badge-secondary">Sem Contato</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Retornar (Não Estava)') {
                                            <span class="badge badge-other">Retornar (Não Estava)</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Retornar (Proposta)') {
                                            <span class="badge badge-info">Retornar (Proposta)</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Venda Realizada') {
                                            <span class="badge badge-success">Venda Realizada</span>
                                          }
                                        </div>
                                        <div class="tabela_card_item_badge pr-1">
                                          @if (ligacaoAnalitica.relationship == 'Ativo') {
                                            <span class="badge badge-warning">Ativo</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Ativo batido') {
                                            <span class="badge badge-success">Ativo (Batido)</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Ativo Premium') {
                                            <span class="badge badge-other">Ativo (Premium)</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Inativo') {
                                            <span class="badge badge-danger">Inativo</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Prospecção') {
                                            <span class="badge badge-primary">Prospecção</span>
                                          }
                                        </div>
                                        <div class="pr-1">
                                          @if (ligacaoAnalitica.tipo == 'E') {
                                            <span class="badge badge-primary">E</span>
                                          }
                                          @if (ligacaoAnalitica.tipo == 'F') {
                                            <span class="badge badge-success">F</span>
                                          }
                                          @if (ligacaoAnalitica.tipo == 'R') {
                                            <span class="badge badge-warning">R</span>
                                          }
                                          @if (ligacaoAnalitica.tipo == 'W') {
                                            <span class="badge badge-info">W</span>
                                          }
                                        </div>
                                        @if (ligacaoAnalitica.flag_atencao == 'S') {
                                          <span class="atencao">&nbsp;</span>
                                        }
                                      </div>
                                      <!-- Dados Complementares -->
                                      <div class="tabela_card_item_quadro text-center mr-1">
                                        <div class="d-flex flex-column">
                                          <table>
                                            @if (ligacaoAnalitica.call_center_prox_agenda != null) {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                              </tr>
                                            }
                                            @if (callCenterConfiguracao != null && callCenterConfiguracao.mostra_classificacao) {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Classificação</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.classificacao }}</td>
                                              </tr>
                                            }
                                            @if (ligacaoAnalitica.ult_compra != null && ligacaoAnalitica.ult_compra != '') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Compra</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_compra | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultcompra }} Dias</td>
                                              </tr>
                                            }
                                            @if (ligacaoAnalitica.status_name != 'ì Ligar') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Ligação</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.data_ligacao | date: 'HH:mm' }}</td>
                                              </tr>
                                            }
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.segment }}</td>
                                            </tr>
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Vendedor(a)</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.fullname }}</td>
                                            </tr>
                                            @if (ligacaoAnalitica.ult_visit != null && ligacaoAnalitica.ult_visit != '') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Visita</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_visit | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultvis }} Dias</td>
                                              </tr>
                                            }
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Mês -->
                                  <div class="tabela_card_item_quadro p-1">
                                    <div class="d-flex flex-column">
                                      <div class="text-center">
                                        Mês
                                      </div>
                                      <div class="d-flex">
                                        <div class="text-right tabela_card_item_valor">
                                          Objetivo
                                          <br />
                                          {{ ligacaoAnalitica.objetivo_venda | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Realizado
                                          <br />
                                          {{ ligacaoAnalitica.realizado_venda | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Falta Vender
                                          <br />
                                          {{ ligacaoAnalitica.falta_vender | currency: 'BRL' : '' }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Tags -->
                                <div class="d-flex flex-wrap">
                                  @for (cliente_tag of ligacaoAnalitica.cliente_tags; track cliente_tag) {
                                    <div class="tabela_card_item_tag">
                                      {{ cliente_tag.descricao }}
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              }
              @if (modelo_tela_ligacoes == 1) {
                <!-- Modelo 2 -->
                <!-- Exibição = Card -->
                @if (ligacoesAnaliticas.length > 0 || filtrado) {
                  <div class="pb-2">
                    <ng-container *ngTemplateOutlet="formularioFiltrar; context: { filtrar: filtrar.bind(this) }"></ng-container>
                    <div class="form-row">
                      <div class="form-group col-sm-2">
                        <label class="text-secondary"><b>Ordenar por:</b></label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por" [(ngModel)]="ordernarLigacoesSelecionado" (change)="ordernarLigacoes($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoes; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                      <div class="form-group col-sm-2">
                        <label class="text-secondary">&nbsp;</label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por_ordem" [(ngModel)]="ordernarLigacoesOrdemSelecionado" (change)="ordernarLigacoesOrdem($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoesOrdem; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesOrdemSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                <cdk-virtual-scroll-viewport class="tabela_xl" [itemSize]="20">
                  <table class="tabela_card">
                    <tbody>
                      <tr *cdkVirtualFor="let ligacaoAnalitica of ligacoesAnaliticas; let i = index; templateCacheSize: 0;">
                        <td>
                          <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="ligacaoAnalitica.id_tmk != null && ligacaoAnalitica.id_tmk != seller_id ? 'bg_tabela_danger' : ((i % 2) == 0) ? 'bg_tabela' : ''">
                            <div class="flex-grow-1">
                              <!-- Cliente -->
                              <div class="tabela_card_item_destaque mb-1">
                                <div class="d-flex justify-content-between">
                                  <div class="d-flex">
                                    @if (ligacaoAnalitica.status_name != 'Não Comprou' && ligacaoAnalitica.status_name != 'Venda Realizada') {
                                      <i class="fa fa-phone btn_tabela_acao pr-1" placement="right" ngbTooltip="Alterar Ligação" (click)="alterarLigacao(ligacaoAnalitica.id)"></i>
                                    }
                                    @if (ligacaoAnalitica.mensagem != null && ligacaoAnalitica.mensagem != '') {
                                      <i class="fa fa-info btn_tabela_acao pr-1" placement="right" ngbTooltip="Mensagem" (click)="modalLigacaoMensagem(ligacaoMensagem, ligacaoAnalitica.mensagem)"></i>
                                    }
                                    <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'ligacoes', ligacaoAnalitica.client_id)"></i>
                                    <div>
                                      {{ ligacaoAnalitica.name }}
                                    </div>
                                  </div>
                                  <div class="d-flex">
                                    <div>
                                      {{ ligacaoAnalitica.estado }}
                                    </div>
                                    @if (ligacaoAnalitica.client_document != null) {
                                      <div>
                                        &nbsp;- {{ ligacaoAnalitica.client_document }}
                                      </div>
                                    }
                                    @if (ligacaoAnalitica.zona_vendas != null) {
                                      <div>
                                        &nbsp;- {{ ligacaoAnalitica.zona_vendas }}
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex">
                                <div class="flex-grow-1">
                                  <div class="d-flex flex-column">
                                    <!-- Badges -->
                                    <div class="d-flex mb-1">
                                      <div class="tabela_card_item_badge pr-1">
                                        @if (ligacaoAnalitica.status_name == 'ì Ligar') {
                                          <span class="badge badge-primary">ì Ligar</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Agendada') {
                                          <span class="badge badge-warning">Agendada</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Não Comprou') {
                                          <span class="badge badge-danger">Não Comprou</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Sem Contato') {
                                          <span class="badge badge-secondary">Sem Contato</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Retornar (Não Estava)') {
                                          <span class="badge badge-other">Retornar (Não Estava)</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Retornar (Proposta)') {
                                          <span class="badge badge-info">Retornar (Proposta)</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Venda Realizada') {
                                          <span class="badge badge-success">Venda Realizada</span>
                                        }
                                      </div>
                                      <div class="tabela_card_item_badge pr-1">
                                        @if (ligacaoAnalitica.relationship == 'Ativo') {
                                          <span class="badge badge-warning">Ativo</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Ativo batido') {
                                          <span class="badge badge-success">Ativo (Batido)</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Ativo Premium') {
                                          <span class="badge badge-other">Ativo (Premium)</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Inativo') {
                                          <span class="badge badge-danger">Inativo</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Prospecção') {
                                          <span class="badge badge-primary">Prospecção</span>
                                        }
                                      </div>
                                      <div class="pr-1">
                                        @if (ligacaoAnalitica.tipo == 'E') {
                                          <span class="badge badge-primary">E</span>
                                        }
                                        @if (ligacaoAnalitica.tipo == 'F') {
                                          <span class="badge badge-success">F</span>
                                        }
                                        @if (ligacaoAnalitica.tipo == 'R') {
                                          <span class="badge badge-warning">R</span>
                                        }
                                        @if (ligacaoAnalitica.tipo == 'W') {
                                          <span class="badge badge-info">W</span>
                                        }
                                      </div>
                                      @if (ligacaoAnalitica.flag_atencao == 'S') {
                                        <span class="atencao">&nbsp;</span>
                                      }
                                    </div>
                                    <!-- Dados Complementares -->
                                    <div class="tabela_card_item_quadro text-center mr-1">
                                      <div class="d-flex flex-column">
                                        <table>
                                          @if (ligacaoAnalitica.call_center_prox_agenda != null) {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                            </tr>
                                          }
                                          @if (ligacaoAnalitica.ult_compra != null && ligacaoAnalitica.ult_compra != '') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Compra</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_compra | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultcompra }} Dias</td>
                                            </tr>
                                          }
                                          @if (ligacaoAnalitica.status_name != 'ì Ligar') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Ligação</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.data_ligacao | date: 'HH:mm' }}</td>
                                            </tr>
                                          }
                                          <tr>
                                            <td class="tabela_card_item_tabela_titulo">PV</td>
                                            <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.pv }}</td>
                                          </tr>
                                          <tr>
                                            <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                            <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.segment }}</td>
                                          </tr>
                                          @if (ligacaoAnalitica.ult_visit != null && ligacaoAnalitica.ult_visit != '') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Visita</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_visit | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultvis }} Dias</td>
                                            </tr>
                                          }
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Ano -->
                                <div class="tabela_card_item_quadro p-1 mr-1">
                                  <div class="d-flex flex-column">
                                    <div class="text-center">
                                      Ano
                                    </div>
                                    <div class="d-flex">
                                      <div class="text-right tabela_card_item_valor">
                                        Potêncial
                                        <br />
                                        {{ ligacaoAnalitica.potencial_ano | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Realizado
                                        <br />
                                        {{ ligacaoAnalitica.realizado_ano | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_porcentagem">
                                        %
                                        <br />
                                        {{ ligacaoAnalitica.porcentagem_ano | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Falta
                                        <br />
                                        {{ ligacaoAnalitica.falta_ano | currency: 'BRL' : '' }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Mês -->
                                <div class="tabela_card_item_quadro p-1">
                                  <div class="d-flex flex-column">
                                    <div class="text-center">
                                      Mês
                                    </div>
                                    <div class="d-flex">
                                      <div class="text-right tabela_card_item_valor">
                                        Objetivo
                                        <br />
                                        {{ ligacaoAnalitica.objetivo_venda | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Realizado
                                        <br />
                                        {{ ligacaoAnalitica.realizado_venda | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_porcentagem">
                                        %
                                        <br />
                                        {{ ligacaoAnalitica.porcentagem_venda | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Anterior
                                        <br />
                                        {{ ligacaoAnalitica.realizado_venda_mesanterior | currency: 'BRL' : '' }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Tags -->
                              <div class="d-flex flex-wrap">
                                @for (cliente_tag of ligacaoAnalitica.cliente_tags; track cliente_tag) {
                                  <div class="tabela_card_item_tag">
                                    {{ cliente_tag.descricao }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              }
            </div>
          </div>
        </ng-template>
      </li>
      <!-- Ligações -->
      <li class="d-none" [ngbNavItem]="'ligacoes'">
        <a ngbNavLink>
          <b>Ligações</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <div class="d-flex quadro_estatistica justify-content-center">
              <div class="flex-grow-1">
                <div class="d-flex flex-wrap align-content-start justify-content-center">
                  <!-- Qtde Realizado -->
                  <div class="quadros_numeros_lg p-2">
                    <div class="d-flex align-items-center">
                      <div class="pl-2 pr-2">
                        <i class="fa fa-phone quadros_numeros_icones"></i>
                      </div>
                      <div class="quadros_numeros_textos">
                        {{ qtdeRealizado }}<br />Qtde Realizado
                      </div>
                      <div class="quadros_numeros_porcentagem">
                        {{ porcentagemQtdeRealizado | currency: 'BRL' : '' }}%
                      </div>
                    </div>
                  </div>
                  <!-- Meta do Dia -->
                  <div class="quadros_numeros_lg p-2">
                    <div class="d-flex align-items-center">
                      <div class="pl-2 pr-2">
                        <i class="fa fa-dollar quadros_numeros_icones"></i>
                      </div>
                      <div class="quadros_numeros_textos">
                        {{ valorMetaDia | currency: 'BRL' }}<br />Meta do Dia
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Gráfico de Status de Chamadas -->
              <div class="grafico_status p-2">
                <div style="display: block;">
                  <canvas baseChart
                    [data]="pieChartData"
                    [type]="pieChartType"
                    [options]="pieChartOptions"
                    [plugins]="pieChartPlugins"
                    height="120">
                  </canvas>
                </div>
              </div>
            </div>
            <hr class="mt-2 mb-2" />
            <div class="d-flex flex-column">
              @if (modelo_tela_ligacoes == 0) {
                <!-- Modelo 1 -->
                <!-- Exibição = Card -->
                @if (ligacoesAnaliticas.length > 0 || filtrado) {
                  <div class="pb-2">
                    <ng-container *ngTemplateOutlet="formularioFiltrar; context: { filtrar: filtrar.bind(this) }"></ng-container>
                    <div class="form-row">
                      <div class="form-group col-sm-2">
                        <label class="text-secondary"><b>Ordenar por:</b></label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por" [(ngModel)]="ordernarLigacoesSelecionado" (change)="ordernarLigacoes($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoes; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                      <div class="form-group col-sm-2">
                        <label class="text-secondary">&nbsp;</label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por_ordem" [(ngModel)]="ordernarLigacoesOrdemSelecionado" (change)="ordernarLigacoesOrdem($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoesOrdem; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesOrdemSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                <table class="tabela_card">
                  <tbody>
                    @for (ligacaoAnalitica of ligacoesAnaliticas; track ligacaoAnalitica; let i = $index) {
                      <tr>
                        @if (ligacaoAnalitica.exibir) {
                          <td>
                            <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="{ 'bg_tabela' : ((i % 2) == 0) }">
                              <div class="flex-grow-1">
                                <!-- Cliente -->
                                <div class="tabela_card_item_destaque mb-1">
                                  <div class="d-flex justify-content-between">
                                    <div class="d-flex">
                                      @if (ligacaoAnalitica.status_name != 'Não Comprou' && ligacaoAnalitica.status_name != 'Venda Realizada') {
                                        <i class="fa fa-phone btn_tabela_acao pr-1" placement="right" ngbTooltip="Alterar Ligação" (click)="alterarLigacao(ligacaoAnalitica.id)"></i>
                                      }
                                      @if (ligacaoAnalitica.mensagem != null && ligacaoAnalitica.mensagem != '') {
                                        <i class="fa fa-info btn_tabela_acao pr-1" placement="right" ngbTooltip="Mensagem" (click)="modalLigacaoMensagem(ligacaoMensagem, ligacaoAnalitica.mensagem)"></i>
                                      }
                                      <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'ligacoes', ligacaoAnalitica.client_id)"></i>
                                      <div>
                                        {{ ligacaoAnalitica.name }}
                                      </div>
                                    </div>
                                    <div class="d-flex">
                                      <div>
                                        {{ ligacaoAnalitica.cidade }}
                                      </div>
                                      @if (ligacaoAnalitica.estado != null) {
                                        <div>
                                          &nbsp;- {{ ligacaoAnalitica.estado }}
                                        </div>
                                      }
                                      @if (ligacaoAnalitica.client_document != null) {
                                        <div>
                                          &nbsp;- {{ ligacaoAnalitica.client_document }}
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex">
                                  <div class="flex-grow-1">
                                    <div class="d-flex flex-column">
                                      <!-- Bagdes -->
                                      <div class="d-flex mb-1">
                                        <div class="tabela_card_item_badge pr-1">
                                          @if (ligacaoAnalitica.status_name == 'ì Ligar') {
                                            <span class="badge badge-primary">ì Ligar</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Agendada') {
                                            <span class="badge badge-warning">Agendada</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Não Comprou') {
                                            <span class="badge badge-danger">Não Comprou</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Sem Contato') {
                                            <span class="badge badge-secondary">Sem Contato</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Retornar (Não Estava)') {
                                            <span class="badge badge-other">Retornar (Não Estava)</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Retornar (Proposta)') {
                                            <span class="badge badge-info">Retornar (Proposta)</span>
                                          }
                                          @if (ligacaoAnalitica.status_name == 'Venda Realizada') {
                                            <span class="badge badge-success">Venda Realizada</span>
                                          }
                                        </div>
                                        <div class="tabela_card_item_badge pr-1">
                                          @if (ligacaoAnalitica.relationship == 'Ativo') {
                                            <span class="badge badge-warning">Ativo</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Ativo batido') {
                                            <span class="badge badge-success">Ativo (Batido)</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Ativo Premium') {
                                            <span class="badge badge-other">Ativo (Premium)</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Inativo') {
                                            <span class="badge badge-danger">Inativo</span>
                                          }
                                          @if (ligacaoAnalitica.relationship == 'Prospecção') {
                                            <span class="badge badge-primary">Prospecção</span>
                                          }
                                        </div>
                                        <div class="pr-1">
                                          @if (ligacaoAnalitica.tipo == 'E') {
                                            <span class="badge badge-primary">E</span>
                                          }
                                          @if (ligacaoAnalitica.tipo == 'F') {
                                            <span class="badge badge-success">F</span>
                                          }
                                          @if (ligacaoAnalitica.tipo == 'R') {
                                            <span class="badge badge-warning">R</span>
                                          }
                                          @if (ligacaoAnalitica.tipo == 'W') {
                                            <span class="badge badge-info">W</span>
                                          }
                                        </div>
                                        @if (ligacaoAnalitica.flag_atencao == 'S') {
                                          <span class="atencao">&nbsp;</span>
                                        }
                                      </div>
                                      <!-- Dados Complementares -->
                                      <div class="tabela_card_item_quadro text-center mr-1">
                                        <div class="d-flex flex-column">
                                          <table>
                                            @if (ligacaoAnalitica.call_center_prox_agenda != null) {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                              </tr>
                                            }
                                            @if (callCenterConfiguracao != null && callCenterConfiguracao.mostra_classificacao) {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Classificação</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.classificacao }}</td>
                                              </tr>
                                            }
                                            @if (ligacaoAnalitica.ult_compra != null && ligacaoAnalitica.ult_compra != '') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Compra</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_compra | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultcompra }} Dias</td>
                                              </tr>
                                            }
                                            @if (ligacaoAnalitica.status_name != 'ì Ligar') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Ligação</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.data_ligacao | date: 'HH:mm' }}</td>
                                              </tr>
                                            }
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.segment }}</td>
                                            </tr>
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Vendedor(a)</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.fullname }}</td>
                                            </tr>
                                            @if (ligacaoAnalitica.ult_visit != null && ligacaoAnalitica.ult_visit != '') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Visita</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_visit | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultvis }} Dias</td>
                                              </tr>
                                            }
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Mês -->
                                  <div class="tabela_card_item_quadro p-1">
                                    <div class="d-flex flex-column">
                                      <div class="text-center">
                                        Mês
                                      </div>
                                      <div class="d-flex">
                                        <div class="text-right tabela_card_item_valor">
                                          Objetivo
                                          <br />
                                          {{ ligacaoAnalitica.objetivo_venda | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Realizado
                                          <br />
                                          {{ ligacaoAnalitica.realizado_venda | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Falta Vender
                                          <br />
                                          {{ ligacaoAnalitica.falta_vender | currency: 'BRL' : '' }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Tags -->
                                <div class="d-flex flex-wrap">
                                  @for (cliente_tag of ligacaoAnalitica.cliente_tags; track cliente_tag) {
                                    <div class="tabela_card_item_tag">
                                      {{ cliente_tag.descricao }}
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              }
              @if (modelo_tela_ligacoes == 1) {
                <!-- Modelo 2 -->
                <!-- Exibição = Card -->
                @if (ligacoesAnaliticas.length > 0 || filtrado) {
                  <div class="pb-2">
                    <ng-container *ngTemplateOutlet="formularioFiltrar; context: { filtrar: filtrar.bind(this) }"></ng-container>
                    <div class="form-row">
                      <div class="form-group col-sm-2">
                        <label class="text-secondary"><b>Ordenar por:</b></label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por" [(ngModel)]="ordernarLigacoesSelecionado" (change)="ordernarLigacoes($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoes; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                      <div class="form-group col-sm-2">
                        <label class="text-secondary">&nbsp;</label>
                        <select class="form-control form-control-sm" name="ordernar_ligacoes_por_ordem" [(ngModel)]="ordernarLigacoesOrdemSelecionado" (change)="ordernarLigacoesOrdem($event.target.value)">
                          @for (opcao of ordernarLigacoesOpcoesOrdem; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarLigacoesOrdemSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                <cdk-virtual-scroll-viewport class="tabela_xl" [itemSize]="20">
                  <table class="tabela_card">
                    <tbody>
                      <tr *cdkVirtualFor="let ligacaoAnalitica of ligacoesAnaliticas; let i = index; templateCacheSize: 0;">
                        <td>
                          <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="ligacaoAnalitica.id_tmk != null && ligacaoAnalitica.id_tmk != seller_id ? 'bg_tabela_danger' : ((i % 2) == 0) ? 'bg_tabela' : ''">
                            <div class="flex-grow-1">
                              <!-- Cliente -->
                              <div class="tabela_card_item_destaque mb-1">
                                <div class="d-flex justify-content-between">
                                  <div class="d-flex">
                                    @if (ligacaoAnalitica.status_name != 'Não Comprou' && ligacaoAnalitica.status_name != 'Venda Realizada') {
                                      <i class="fa fa-phone btn_tabela_acao pr-1" placement="right" ngbTooltip="Alterar Ligação" (click)="alterarLigacao(ligacaoAnalitica.id)"></i>
                                    }
                                    @if (ligacaoAnalitica.mensagem != null && ligacaoAnalitica.mensagem != '') {
                                      <i class="fa fa-info btn_tabela_acao pr-1" placement="right" ngbTooltip="Mensagem" (click)="modalLigacaoMensagem(ligacaoMensagem, ligacaoAnalitica.mensagem)"></i>
                                    }
                                    <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'ligacoes', ligacaoAnalitica.client_id)"></i>
                                    <div>
                                      {{ ligacaoAnalitica.name }}
                                    </div>
                                  </div>
                                  <div class="d-flex">
                                    <div>
                                      {{ ligacaoAnalitica.estado }}
                                    </div>
                                    @if (ligacaoAnalitica.client_document != null) {
                                      <div>
                                        &nbsp;- {{ ligacaoAnalitica.client_document }}
                                      </div>
                                    }
                                    @if (ligacaoAnalitica.zona_vendas != null) {
                                      <div>
                                        &nbsp;- {{ ligacaoAnalitica.zona_vendas }}
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex">
                                <div class="flex-grow-1">
                                  <div class="d-flex flex-column">
                                    <!-- Badges -->
                                    <div class="d-flex mb-1">
                                      <div class="tabela_card_item_badge pr-1">
                                        @if (ligacaoAnalitica.status_name == 'ì Ligar') {
                                          <span class="badge badge-primary">ì Ligar</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Agendada') {
                                          <span class="badge badge-warning">Agendada</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Não Comprou') {
                                          <span class="badge badge-danger">Não Comprou</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Sem Contato') {
                                          <span class="badge badge-secondary">Sem Contato</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Retornar (Não Estava)') {
                                          <span class="badge badge-other">Retornar (Não Estava)</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Retornar (Proposta)') {
                                          <span class="badge badge-info">Retornar (Proposta)</span>
                                        }
                                        @if (ligacaoAnalitica.status_name == 'Venda Realizada') {
                                          <span class="badge badge-success">Venda Realizada</span>
                                        }
                                      </div>
                                      <div class="tabela_card_item_badge pr-1">
                                        @if (ligacaoAnalitica.relationship == 'Ativo') {
                                          <span class="badge badge-warning">Ativo</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Ativo batido') {
                                          <span class="badge badge-success">Ativo (Batido)</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Ativo Premium') {
                                          <span class="badge badge-other">Ativo (Premium)</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Inativo') {
                                          <span class="badge badge-danger">Inativo</span>
                                        }
                                        @if (ligacaoAnalitica.relationship == 'Prospecção') {
                                          <span class="badge badge-primary">Prospecção</span>
                                        }
                                      </div>
                                      <div class="pr-1">
                                        @if (ligacaoAnalitica.tipo == 'E') {
                                          <span class="badge badge-primary">E</span>
                                        }
                                        @if (ligacaoAnalitica.tipo == 'F') {
                                          <span class="badge badge-success">F</span>
                                        }
                                        @if (ligacaoAnalitica.tipo == 'R') {
                                          <span class="badge badge-warning">R</span>
                                        }
                                        @if (ligacaoAnalitica.tipo == 'W') {
                                          <span class="badge badge-info">W</span>
                                        }
                                      </div>
                                      @if (ligacaoAnalitica.flag_atencao == 'S') {
                                        <span class="atencao">&nbsp;</span>
                                      }
                                    </div>
                                    <!-- Dados Complementares -->
                                    <div class="tabela_card_item_quadro text-center mr-1">
                                      <div class="d-flex flex-column">
                                        <table>
                                          @if (ligacaoAnalitica.call_center_prox_agenda != null) {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                            </tr>
                                          }
                                          @if (ligacaoAnalitica.ult_compra != null && ligacaoAnalitica.ult_compra != '') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Compra</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_compra | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultcompra }} Dias</td>
                                            </tr>
                                          }
                                          @if (ligacaoAnalitica.status_name != 'ì Ligar') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Ligação</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.data_ligacao | date: 'HH:mm' }}</td>
                                            </tr>
                                          }
                                          <tr>
                                            <td class="tabela_card_item_tabela_titulo">PV</td>
                                            <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.pv }}</td>
                                          </tr>
                                          <tr>
                                            <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                            <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.segment }}</td>
                                          </tr>
                                          @if (ligacaoAnalitica.ult_visit != null && ligacaoAnalitica.ult_visit != '') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Visita</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ ligacaoAnalitica.ult_visit | date: 'dd/MM/yyyy' }} - {{ ligacaoAnalitica.qtdediasultvis }} Dias</td>
                                            </tr>
                                          }
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Ano -->
                                <div class="tabela_card_item_quadro p-1 mr-1">
                                  <div class="d-flex flex-column">
                                    <div class="text-center">
                                      Ano
                                    </div>
                                    <div class="d-flex">
                                      <div class="text-right tabela_card_item_valor">
                                        Potêncial
                                        <br />
                                        {{ ligacaoAnalitica.potencial_ano | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Realizado
                                        <br />
                                        {{ ligacaoAnalitica.realizado_ano | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_porcentagem">
                                        %
                                        <br />
                                        {{ ligacaoAnalitica.porcentagem_ano | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Falta
                                        <br />
                                        {{ ligacaoAnalitica.falta_ano | currency: 'BRL' : '' }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Mês -->
                                <div class="tabela_card_item_quadro p-1">
                                  <div class="d-flex flex-column">
                                    <div class="text-center">
                                      Mês
                                    </div>
                                    <div class="d-flex">
                                      <div class="text-right tabela_card_item_valor">
                                        Objetivo
                                        <br />
                                        {{ ligacaoAnalitica.objetivo_venda | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Realizado
                                        <br />
                                        {{ ligacaoAnalitica.realizado_venda | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_porcentagem">
                                        %
                                        <br />
                                        {{ ligacaoAnalitica.porcentagem_venda | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Anterior
                                        <br />
                                        {{ ligacaoAnalitica.realizado_venda_mesanterior | currency: 'BRL' : '' }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Tags -->
                              <div class="d-flex flex-wrap">
                                @for (cliente_tag of ligacaoAnalitica.cliente_tags; track cliente_tag) {
                                  <div class="tabela_card_item_tag">
                                    {{ cliente_tag.descricao }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              }
            </div>
          </div>
        </ng-template>
      </li>
      <!-- CRM Ligações -->
      <li [ngbNavItem]="'crm-ligacoes'">
        <a ngbNavLink>
          <b>CRM Ligações</b>
        </a>
        <ng-template ngbNavContent>
          <div class="crm-ligacoes-wrapper pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <div class="crm-filtros">
              <label>
                <span>Data Ligação</span>
                <input class="form-control"
                       type="date"
                       list="crmDatasLigacaoDisponiveis"
                       [(ngModel)]="crmFiltroDataLigacao"
                       (change)="aplicarFiltrosCrmLigacoes()"
                       (input)="aplicarFiltrosCrmLigacoes()" />
                <datalist id="crmDatasLigacaoDisponiveis">
                  @for (data of crmDatasLigacaoFiltro; track data) {
                    <option [value]="data"></option>
                  }
                </datalist>
              </label>

              <label>
                <span>Cliente</span>
                <input class="form-control"
                       type="text"
                       list="crmClientesDisponiveis"
                       placeholder="Todos"
                       [(ngModel)]="crmFiltroCliente"
                       (input)="aplicarFiltrosCrmLigacoes()" />
                <datalist id="crmClientesDisponiveis">
                  @for (cliente of crmClientesFiltro; track cliente.id) {
                    <option [value]="cliente.nome"></option>
                  }
                </datalist>
              </label>

              <label>
                <span>Vend. interna</span>
                <select class="form-control" [(ngModel)]="crmFiltroVendInterna" (change)="aplicarFiltrosCrmLigacoes()">
                  <option value="">Todas</option>
                  @for (vendInterna of crmVendedorasInternasFiltro; track vendInterna) {
                    <option [value]="vendInterna">{{ vendInterna }}</option>
                  }
                </select>
              </label>

              <label>
                <span>Vendedor</span>
                <select class="form-control" [(ngModel)]="crmFiltroVendedor" (change)="aplicarFiltrosCrmLigacoes()">
                  <option value="">Todos</option>
                  @for (vendedor of crmVendedoresFiltroDinamico(); track vendedor.id) {
                    <option [value]="vendedor.id">{{ vendedor.nome }}</option>
                  }
                </select>
              </label>

              <label>
                <span>Cidade</span>
                <select class="form-control" [(ngModel)]="crmFiltroCidade" (change)="aplicarFiltrosCrmLigacoes()">
                  <option value="">Todas</option>
                  @for (cidade of crmCidadesFiltroDinamico(); track cidade) {
                    <option [value]="cidade">{{ cidade }}</option>
                  }
                </select>
              </label>

              <label>
                <span>Tem Mensagem</span>
                <select class="form-control" [(ngModel)]="crmFiltroTemMensagem" (change)="aplicarFiltrosCrmLigacoes()">
                  <option value="">Todos</option>
                  <option value="S">SIM</option>
                  <option value="N">NAO</option>
                </select>
              </label>

              <button class="btn btn-outline-secondary crm-filtros-limpar" type="button" (click)="limparFiltrosCrmLigacoes()">Limpar</button>
            </div>

            <div class="crm-kanban-board"
                 [class.crm-kanban-board-dragging]="crmBoardArrastando"
                 (pointerdown)="iniciarArrasteCrmBoard($event)"
                 (pointermove)="arrastarCrmBoard($event)"
                 (pointerup)="finalizarArrasteCrmBoard()"
                 (pointercancel)="finalizarArrasteCrmBoard()"
                 (pointerleave)="finalizarArrasteCrmBoard()">
              @for (etapa of crmEtapas; track etapa.id) {
                <div class="crm-kanban-column" [class.crm-kanban-column-hoje]="etapa.codigo == 'HOJE'" [style.border-top-color]="etapa.cor">
                  <div class="crm-kanban-column-header">
                    <div class="crm-stage-title">
                      <span class="crm-stage-pill" [style.background-color]="etapa.cor">{{ etapa.nome }}</span>
                      @if (etapa.codigo == 'ATRASADAS' && podeVisualizarCrmCalendarioGeral) {
                        <button class="crm-stage-inativar-btn" type="button" title="Inativar atrasadas em massa" (click)="abrirInativacaoMassaAtrasadas(crmInativarAtrasadasMassa)">
                          <i class="fa fa-times"></i>
                        </button>
                      }
                      @if (etapa.codigo == 'FUTURAS') {
                        <button class="crm-stage-calendar-btn" type="button" title="Calendario de ligacoes futuras" (click)="abrirCrmCalendarioFuturas(crmCalendarioFuturas)">
                          <i class="fa fa-calendar"></i>
                        </button>
                      }
                    </div>
                    <div class="crm-stage-count">{{ crmLigacoesPorEtapa(etapa).length }}</div>
                  </div>

                  <div class="crm-kanban-list" (scroll)="carregarMaisCrmLigacoesEtapa(etapa, $event)">
                    @for (ligacao of crmLigacoesVisiveis(etapa); track ligacao.id) {
                      <div class="crm-call-card">
                        <div class="crm-card-top">
                          <div class="crm-card-top-left">
                            @if (ligacao.etapa_codigo != 'GANHO' && ligacao.etapa_codigo != 'PERDA') {
                              <button class="crm-icon-action" type="button" title="Ligar" (click)="alterarLigacao(ligacao.id)">
                                <i class="fa fa-phone"></i>
                              </button>
                            }
                            <button class="crm-icon-action" type="button" title="Tags" (click)="modalTagsClientes(tagsClientes, 'crm-ligacoes', ligacao.client_id)">
                              <i class="fa fa-tag"></i>
                            </button>
                            @if (ligacao.mensagem != null && ligacao.mensagem != '') {
                              <button class="crm-icon-action" type="button" title="Mensagem" (click)="modalLigacaoMensagem(ligacaoMensagem, ligacao.mensagem)">
                                <i class="fa fa-info"></i>
                              </button>
                            }
                            @if (podeVisualizarCrmCalendarioGeral) {
                              <button class="crm-icon-action crm-icon-action-danger" type="button" title="Inativar ligacao" (click)="inativarCrmLigacao(ligacao)">
                                <i class="fa fa-times"></i>
                              </button>
                            }
                            <span class="crm-date-badge" [ngClass]="{ 'crm-date-late': ligacao.faixa_data == 'ATRASADA', 'crm-date-today': ligacao.faixa_data == 'HOJE', 'crm-date-future': ligacao.faixa_data == 'FUTURA' }">
                              {{ crmDataTexto(ligacao) }}
                            </span>
                          </div>
                          <span class="crm-id-badge">ID: {{ ligacao.id }}</span>
                        </div>

                        <div class="crm-card-title">{{ ligacao.name }}</div>
                        <div class="crm-card-muted">{{ ligacao.client_document }} ⬢ {{ ligacao.cidade }}{{ ligacao.estado != null ? ' - ' + ligacao.estado : '' }}</div>
                        <div class="crm-card-segmento">Segmento: {{ ligacao.segment || '-' }}</div>

                        <div class="crm-card-badges">
                          <span class="crm-status-badge" [ngClass]="crmStatusClasse(ligacao.status_name)">{{ ligacao.status_name || 'Sem status' }}</span>
                          <span class="crm-client-badge" [ngClass]="crmRelationshipClasse(ligacao.relationship)">{{ ligacao.relationship || 'Sem status cliente' }}</span>
                        </div>

                        <div class="crm-card-grid">
                          <div>
                            <span>Vendedor</span>
                            <b>{{ ligacao.fullname || '-' }}</b>
                          </div>
                          <div>
                            <span>Vend. interna</span>
                            <b>{{ ligacao.vendinterna || '-' }}</b>
                          </div>
                          @if (ligacao.credito_financeiro != null) {
                            <div>
                              <span>Credito disp.</span>
                              <b>{{ ligacao.credito_financeiro | currency: 'BRL' }}</b>
                            </div>
                          }
                          @if (ligacao.limite_credito_disponivel != null) {
                            <div>
                              <span>Limite disp.</span>
                              <b>{{ ligacao.limite_credito_disponivel | currency: 'BRL' }}</b>
                            </div>
                          }
                          <div>
                            <span>Ult. Compra</span>
                            <b>{{ ligacao.ult_compra | date: 'dd/MM/yyyy' }} {{ ligacao.qtdediasultcompra != null ? '(' + ligacao.qtdediasultcompra + 'd)' : '' }}</b>
                          </div>
                          <div>
                            <span>Ult. Visita</span>
                            <b>{{ ligacao.ult_visit | date: 'dd/MM/yyyy' }} {{ ligacao.qtdediasultvis != null ? '(' + ligacao.qtdediasultvis + 'd)' : '' }}</b>
                          </div>
                        </div>

                        <div class="crm-goal-line" [ngClass]="{ 'crm-goal-hit': (ligacao.falta_vender || 0) == 0 }">
                          <span><small>Objetivo</small><b>{{ (ligacao.objetivo_venda || 0) | currency: 'BRL' }}</b></span>
                          <span><small>Realizado</small><b>{{ (ligacao.realizado_venda || 0) | currency: 'BRL' }}</b></span>
                          <span><small>Falta vender</small><b>{{ (ligacao.falta_vender || 0) | currency: 'BRL' }}</b></span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </li>

      <!-- Oportunidades -->
      <li [ngbNavItem]="'oportunidades'">
        <a ngbNavLink>
          <b>Oportunidades</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <ng-container *ngTemplateOutlet="formularioFiltrar; context: { filtrar: filtrar.bind(this) }"></ng-container>
            @if (oportunidades.length > 0) {
              <div class="d-flex quadro_estatistica justify-content-center">
                <div class="flex-grow-1">
                  <div class="d-flex flex-wrap align-content-start justify-content-center">
                    <!-- Qtde Clientes -->
                    <div class="quadros_numeros_lg p-2">
                      <div class="d-flex align-items-center">
                        <div class="pl-2 pr-2">
                          <i class="fa fa-users quadros_numeros_icones"></i>
                        </div>
                        <div class="quadros_numeros_textos">
                          {{ qtdeClientes }}<br />Qtde Clientes
                        </div>
                      </div>
                    </div>
                    <!-- Qtde Clientes Padrão -->
                    <div class="quadros_numeros_lg p-2">
                      <div class="d-flex align-items-center">
                        <div class="pl-2 pr-2">
                          <i class="fa fa-users quadros_numeros_icones"></i>
                        </div>
                        <div class="quadros_numeros_textos">
                          {{ qtdeClientesPadrao }}<br />Qtde Clientes Padrão
                        </div>
                      </div>
                    </div>
                    <!-- Qtde Clientes Adicionais -->
                    <div class="quadros_numeros_lg p-2">
                      <div class="d-flex align-items-center">
                        <div class="pl-2 pr-2">
                          <i class="fa fa-users quadros_numeros_icones"></i>
                        </div>
                        <div class="quadros_numeros_textos">
                          {{ qtdeClientesAdicionais }}<br />Qtde Clientes Adicionais
                        </div>
                      </div>
                    </div>
                    <!-- Meta do Mês -->
                    <div class="quadros_numeros_lg p-2">
                      <div class="d-flex align-items-center">
                        <div class="pl-2 pr-2">
                          <i class="fa fa-dollar quadros_numeros_icones"></i>
                        </div>
                        <div class="quadros_numeros_textos">
                          {{ valorMetaMes | currency: 'BRL' }}<br />Meta do Mês
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Estatística (Clientes) -->
                <div class="flex-grow-1">
                  <div class="d-flex justify-content-end">
                    <div class="estatistica text-center p-2">
                      <div>
                        <b>Estatística (Clientes)</b>
                      </div>
                      <div class="estatistica_quadro mt-3">
                        @for (estatistica of estatisticasClientes; track estatistica) {
                          <div class="d-flex justify-content-between pr-2 pb-2 pl-2">
                            <div class="estatistica_legenda mr-3" [ngClass]="estatistica.item"></div>
                            <div class="estatistica_legenda_descricao text-left">{{ estatistica.descricao }}</div>
                            <div class="estatistica_legenda_descricao text-right">{{ estatistica.qtde }}</div>
                            <div class="estatistica_legenda_descricao text-right">{{ estatistica.porcentagem | currency: 'BRL' : '' }}%</div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mt-2 mb-2" />
            }
            <div class="d-flex flex-column">
              @if (modelo_tela_ligacoes == 0) {
                <!-- Modelo 1 -->
                <!-- Exibição = Card -->
                @if (oportunidades.length > 0) {
                  <div class="pb-2">
                    <div class="form-row">
                      <div class="form-group col-sm-2">
                        <label class="text-secondary"><b>Ordenar por:</b></label>
                        <select class="form-control form-control-sm" name="ordernar_oportunidades_por" [(ngModel)]="ordernarOportunidadesSelecionado" (change)="ordernarOportunidades($event.target.value)">
                          @for (opcao of ordernarOportunidadesOpcoes; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                      <div class="form-group col-sm-2">
                        <label class="text-secondary">&nbsp;</label>
                        <select class="form-control form-control-sm" name="ordernar_oportunidades_por_ordem" [(ngModel)]="ordernarOportunidadesOrdemSelecionado" (change)="ordernarOportunidadesOrdem($event.target.value)">
                          @for (opcao of ordernarOportunidadesOpcoesOrdem; track opcao) {
                            <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesOrdemSelecionado">{{ opcao.texto }}</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                <cdk-virtual-scroll-viewport class="tabela_xl" [itemSize]="20">
                  <table class="tabela_card">
                    <tbody>
                      <tr *cdkVirtualFor="let oportunidade of oportunidades; let i = index; templateCacheSize: 0;">
                        <td>
                          <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="{ 'bg_tabela' : ((i % 2) == 0) }">
                            <div class="flex-grow-1">
                              <!-- Cliente -->
                              <div class="tabela_card_item_destaque mb-1">
                                <div class="d-flex justify-content-between">
                                  <div class="d-flex">
                                    <i class="fa fa-phone btn_tabela_acao pr-1" placement="right" ngbTooltip="Nova Ligação" (click)="novaLigacao(oportunidade.codigo_no_erp_do_cliente)"></i>
                                    <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'oportunidades', oportunidade.client_id_app)"></i>
                                    <div>
                                      {{ oportunidade.name }}
                                    </div>
                                  </div>
                                  <div class="d-flex">
                                    <div>
                                      {{ oportunidade.cidade }}
                                    </div>
                                    @if (oportunidade.estado != null) {
                                      <div>
                                        &nbsp;- {{ oportunidade.estado }}
                                      </div>
                                    }
                                    @if (oportunidade.client_document != null) {
                                      <div>
                                        &nbsp;- {{ oportunidade.client_document }}
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex">
                                <div class="flex-grow-1">
                                  <div class="d-flex flex-column">
                                    <!-- Bagdes -->
                                    <div class="d-flex mb-1">
                                      <div class="tabela_card_item_badge pr-1">
                                        @if (oportunidade.relationship == 'Ativo') {
                                          <span class="badge badge-warning">Ativo</span>
                                        }
                                        @if (oportunidade.relationship == 'Ativo batido') {
                                          <span class="badge badge-success">Ativo (Batido)</span>
                                        }
                                        @if (oportunidade.relationship == 'Ativo Premium') {
                                          <span class="badge badge-other">Ativo (Premium)</span>
                                        }
                                        @if (oportunidade.relationship == 'Inativo') {
                                          <span class="badge badge-danger">Inativo</span>
                                        }
                                        @if (oportunidade.relationship == 'Prospecção') {
                                          <span class="badge badge-primary">Prospecção</span>
                                        }
                                      </div>
                                      @if (oportunidade.atencao == 'S') {
                                        <span class="atencao">&nbsp;</span>
                                      }
                                    </div>
                                    <!-- Dados Complementares -->
                                    <div class="tabela_card_item_quadro text-center mr-1">
                                      <div class="d-flex flex-column">
                                        <table>
                                          @if (oportunidade.call_center_prox_agenda != null) {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                            </tr>
                                          }
                                          @if (callCenterConfiguracao != null && callCenterConfiguracao.mostra_classificacao) {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Classificação</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.classificacao }}</td>
                                            </tr>
                                          }
                                          @if (oportunidade.ultcomp != null && oportunidade.ultcomp != '') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Compra</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultcomp | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultcomp }} Dias</td>
                                            </tr>
                                          }
                                          <tr>
                                            <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                            <td class="tabela_card_item_tabela_descricao">{{ oportunidade.segment }}</td>
                                          </tr>
                                          <tr>
                                            <td class="tabela_card_item_tabela_titulo">Vendedor(a)</td>
                                            <td class="tabela_card_item_tabela_descricao">{{ oportunidade.fullname }}</td>
                                          </tr>
                                          @if (oportunidade.credito_financeiro != null) {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Credito Disp.</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.credito_financeiro | currency: 'BRL' }}</td>
                                            </tr>
                                          }
                                          @if (oportunidade.limite_credito_disponivel != null) {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Limite Disp.</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.limite_credito_disponivel | currency: 'BRL' }}</td>
                                            </tr>
                                          }
                                          @if (oportunidade.ultvisita != null && oportunidade.ultvisita != '') {
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Visita</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultvisita | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultvisita }} Dias</td>
                                            </tr>
                                          }
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Mês -->
                                <div class="tabela_card_item_quadro p-1">
                                  <div class="d-flex flex-column">
                                    <div class="text-center">
                                      Mês
                                    </div>
                                    <div class="d-flex">
                                      <div class="text-right tabela_card_item_valor">
                                        Objetivo
                                        <br />
                                        {{ oportunidade.objetivo_de_venda | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Realizado
                                        <br />
                                        {{ oportunidade.order_total | currency: 'BRL' : '' }}
                                      </div>
                                      <div class="text-right tabela_card_item_valor">
                                        Falta Vender
                                        <br />
                                        {{ oportunidade.falta_vender | currency: 'BRL' : '' }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Tags -->
                              <div class="d-flex flex-wrap">
                                @for (cliente_tag of oportunidade.cliente_tags; track cliente_tag) {
                                  <div class="tabela_card_item_tag">
                                    {{ cliente_tag.descricao }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              }
              @if (modelo_tela_ligacoes == 1) {
                <!-- Modelo 2 -->
                <!-- Exibição = Card -->
                <div class="pb-2">
                  @if (oportunidades.length > 0) {
                    <div class="pb-2">
                      <div class="form-row">
                        <div class="form-group col-sm-2">
                          <label class="text-secondary"><b>Ordenar por:</b></label>
                          <select class="form-control form-control-sm" name="ordernar_oportunidades_por" [(ngModel)]="ordernarOportunidadesSelecionado" (change)="ordernarOportunidades($event.target.value)">
                            @for (opcao of ordernarOportunidadesOpcoes; track opcao) {
                              <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesSelecionado">{{ opcao.texto }}</option>
                            }
                          </select>
                        </div>
                        <div class="form-group col-sm-2">
                          <label class="text-secondary">&nbsp;</label>
                          <select class="form-control form-control-sm" name="ordernar_oportunidades_por_ordem" [(ngModel)]="ordernarOportunidadesOrdemSelecionado" (change)="ordernarOportunidadesOrdem($event.target.value)">
                            @for (opcao of ordernarOportunidadesOpcoesOrdem; track opcao) {
                              <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesOrdemSelecionado">{{ opcao.texto }}</option>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                  <cdk-virtual-scroll-viewport class="tabela_xl" [itemSize]="20">
                    <table class="tabela_card">
                      <tbody>
                        <tr *cdkVirtualFor="let oportunidade of oportunidades; let i = index; templateCacheSize: 0;">
                          <td>
                            <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="{ 'bg_tabela' : ((i % 2) == 0) }">
                              <div class="flex-grow-1">
                                <!-- Cliente -->
                                <div class="tabela_card_item_destaque mb-1">
                                  <div class="d-flex justify-content-between">
                                    <div class="d-flex">
                                      <i class="fa fa-phone btn_tabela_acao pr-1" placement="right" ngbTooltip="Nova Ligação" (click)="novaLigacao(oportunidade.codigo_no_erp_do_cliente)"></i>
                                      <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'oportunidades', oportunidade.client_id_app)"></i>
                                      <div>
                                        {{ oportunidade.name }}
                                      </div>
                                    </div>
                                    <div class="d-flex">
                                      <div>
                                        {{ oportunidade.estado }}
                                      </div>
                                      @if (oportunidade.client_document != null) {
                                        <div>
                                          &nbsp;- {{ oportunidade.client_document }}
                                        </div>
                                      }
                                      @if (oportunidade.zona_vendas != null) {
                                        <div>
                                          &nbsp;- {{ oportunidade.zona_vendas }}
                                        </div>
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div class="d-flex">
                                  <div class="flex-grow-1">
                                    <div class="d-flex flex-column">
                                      <!-- Bagdes -->
                                      <div class="d-flex mb-1">
                                        <div class="tabela_card_item_badge pr-1">
                                          @if (oportunidade.relationship == 'Ativo') {
                                            <span class="badge badge-warning">Ativo</span>
                                          }
                                          @if (oportunidade.relationship == 'Ativo batido') {
                                            <span class="badge badge-success">Ativo (Batido)</span>
                                          }
                                          @if (oportunidade.relationship == 'Ativo Premium') {
                                            <span class="badge badge-other">Ativo (Premium)</span>
                                          }
                                          @if (oportunidade.relationship == 'Inativo') {
                                            <span class="badge badge-danger">Inativo</span>
                                          }
                                          @if (oportunidade.relationship == 'Prospecção') {
                                            <span class="badge badge-primary">Prospecção</span>
                                          }
                                        </div>
                                        @if (oportunidade.atencao == 'S') {
                                          <span class="atencao">&nbsp;</span>
                                        }
                                      </div>
                                      <!-- Dados Complementares -->
                                      <div class="tabela_card_item_quadro text-center mr-1">
                                        <div class="d-flex flex-column">
                                          <table>
                                            @if (oportunidade.call_center_prox_agenda != null) {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ oportunidade.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                              </tr>
                                            }
                                            @if (oportunidade.ultcomp != null && oportunidade.ultcomp != '') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Compra</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultcomp | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultcomp }} Dias</td>
                                              </tr>
                                            }
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">PV</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.pv }}</td>
                                            </tr>
                                            <tr>
                                              <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                              <td class="tabela_card_item_tabela_descricao">{{ oportunidade.segment }}</td>
                                            </tr>
                                            @if (oportunidade.credito_financeiro != null) {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Credito Disp.</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ oportunidade.credito_financeiro | currency: 'BRL' }}</td>
                                              </tr>
                                            }
                                            @if (oportunidade.limite_credito_disponivel != null) {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Limite Disp.</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ oportunidade.limite_credito_disponivel | currency: 'BRL' }}</td>
                                              </tr>
                                            }
                                            @if (oportunidade.ultvisita != null && oportunidade.ultvisita != '') {
                                              <tr>
                                                <td class="tabela_card_item_tabela_titulo">Visita</td>
                                                <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultvisita | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultvisita }} Dias</td>
                                              </tr>
                                            }
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Ano -->
                                  <div class="tabela_card_item_quadro p-1 mr-1">
                                    <div class="d-flex flex-column">
                                      <div class="text-center">
                                        Ano
                                      </div>
                                      <div class="d-flex">
                                        <div class="text-right tabela_card_item_valor">
                                          Potêncial
                                          <br />
                                          {{ oportunidade.potencial_ano | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Realizado
                                          <br />
                                          {{ oportunidade.realizado_ano | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_porcentagem">
                                          %
                                          <br />
                                          {{ oportunidade.porcentagem_ano | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Falta
                                          <br />
                                          {{ oportunidade.falta_ano | currency: 'BRL' : '' }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- Mês -->
                                  <div class="tabela_card_item_quadro p-1">
                                    <div class="d-flex flex-column">
                                      <div class="text-center">
                                        Mês
                                      </div>
                                      <div class="d-flex">
                                        <div class="text-right tabela_card_item_valor">
                                          Objetivo
                                          <br />
                                          {{ oportunidade.objetivo_de_venda | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Realizado
                                          <br />
                                          {{ oportunidade.realizado_venda | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_porcentagem">
                                          %
                                          <br />
                                          {{ oportunidade.porcentagem_venda | currency: 'BRL' : '' }}
                                        </div>
                                        <div class="text-right tabela_card_item_valor">
                                          Anterior
                                          <br />
                                          {{ oportunidade.realizado_venda_mesanterior | currency: 'BRL' : '' }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- Tags -->
                                <div class="d-flex flex-wrap">
                                  @for (cliente_tag of oportunidade.cliente_tags; track cliente_tag) {
                                    <div class="tabela_card_item_tag">
                                      {{ cliente_tag.descricao }}
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </cdk-virtual-scroll-viewport>
                </div>
              }
              @if (oportunidades.length > 0) {
                <div class="col-sm-12 text-right p-2">
                  <button class="btn btn-link" type="button" (click)="exportarOportunidades()">Exportar p/ Excel</button>
                </div>
              }
            </div>
          </div>
        </ng-template>
      </li>
      <!-- Rotas -->
      <li [ngbNavItem]="'rotas'">
        <a ngbNavLink>
          <b>Rotas</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <div class="form-row align-items-end">
              <div class="form-group col-sm-4">
                <label class="text-secondary"><b>Vendedor(a):</b></label>
                <select class="form-control form-control-sm" name="rota_vendedor" [(ngModel)]="rotaSellerSelecionado" (change)="carregarRotasPorVendedor()">
                  <option [ngValue]="null">Selecione...</option>
                  @for (vendedor of rotasVendedores; track vendedor.id) {
                    <option [ngValue]="vendedor.id">{{ vendedor.fullname }}</option>
                  }
                </select>
              </div>
              <div class="form-group col-sm-4">
                <label class="text-secondary"><b>Rota:</b></label>
                <select class="form-control form-control-sm" name="rota_rota" [(ngModel)]="rotaSelecionada" (change)="carregarClientesDaRota()" [disabled]="rotaSellerSelecionado == null">
                  <option [ngValue]="null">Selecione...</option>
                  @for (rota of rotas; track rota.id) {
                    <option [ngValue]="rota.id">{{ rota.nome }}</option>
                  }
                </select>
              </div>
              <div class="form-group col-sm-2">
                <button class="btn btn-secondary btn-sm btn-block" type="button" (click)="carregarClientesDaRota()" [disabled]="rotaSellerSelecionado == null || rotaSelecionada == null">Atualizar</button>
              </div>
            </div>
            @if (rotasClientes.length > 0) {
              <div class="d-flex quadro_estatistica justify-content-center">
                <div class="quadros_numeros_lg p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-map-marker quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ rotasClientes.length }}<br />Clientes na rota
                    </div>
                  </div>
                </div>
                <div class="quadros_numeros_lg p-2">
                  <div class="d-flex align-items-center">
                    <div class="pl-2 pr-2">
                      <i class="fa fa-check-circle quadros_numeros_icones"></i>
                    </div>
                    <div class="quadros_numeros_textos">
                      {{ qtdeRotasLigacaoOk }}<br />Ligacao OK
                    </div>
                  </div>
                </div>
              </div>
              <hr class="mt-2 mb-2" />
            }
            @if (rotaSellerSelecionado != null && rotaSelecionada != null && rotasClientes.length == 0) {
              <div class="alert alert-light border text-center">
                Nenhum cliente encontrado para esta rota.
              </div>
            }
            <cdk-virtual-scroll-viewport class="tabela_xl" [itemSize]="20">
              <table class="tabela_card">
                <tbody>
                  <tr *cdkVirtualFor="let rotaCliente of rotasClientes; let i = index; templateCacheSize: 0;">
                    <td>
                      <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="{ 'bg_tabela' : ((i % 2) == 0) }">
                        <div class="flex-grow-1">
                          <div class="tabela_card_item_destaque mb-1">
                            <div class="d-flex justify-content-between">
                              <div class="d-flex">
                                <i class="fa fa-phone btn_tabela_acao pr-1" placement="right" ngbTooltip="Nova Ligacao" (click)="novaLigacaoRota(rotaCliente)"></i>
                                <div>
                                  {{ rotaCliente.name }}
                                </div>
                              </div>
                              <div class="d-flex">
                                <div>
                                  {{ rotaCliente.cidade }}
                                </div>
                                @if (rotaCliente.estado != null) {
                                  <div>
                                    &nbsp;- {{ rotaCliente.estado }}
                                  </div>
                                }
                                @if (rotaCliente.client_document != null) {
                                  <div>
                                    &nbsp;- {{ rotaCliente.client_document }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="flex-grow-1">
                              <div class="d-flex flex-column">
                                <div class="d-flex mb-1">
                                  <div class="tabela_card_item_badge pr-1">
                                    @if (rotaCliente.relationship == 'Ativo') {
                                      <span class="badge badge-warning">Ativo</span>
                                    }
                                    @if (rotaCliente.relationship == 'Ativo batido') {
                                      <span class="badge badge-success">Ativo (Batido)</span>
                                    }
                                    @if (rotaCliente.relationship == 'Ativo Premium') {
                                      <span class="badge badge-other">Ativo (Premium)</span>
                                    }
                                    @if (rotaCliente.relationship == 'Inativo') {
                                      <span class="badge badge-danger">Inativo</span>
                                    }
                                    @if (rotaCliente.relationship == 'Prospecção' || rotaCliente.relationship == 'ProspecÒ§Ò£o') {
                                      <span class="badge badge-primary">Prospecção</span>
                                    }
                                  </div>
                                  @if (rotaCliente.ligacao_ok) {
                                    <span class="badge badge-success">Ligacao OK</span>
                                  }
                                </div>
                                <div class="tabela_card_item_quadro text-center mr-1">
                                  <div class="d-flex flex-column">
                                    <table>
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Rota</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ rotaCliente.nome }}</td>
                                      </tr>
                                      @if (rotaCliente.ultima_compra != null) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Compra</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ rotaCliente.ultima_compra | date: 'dd/MM/yyyy' }} - {{ rotaCliente.qtdeDiasUltCompra }} Dias</td>
                                        </tr>
                                      }
                                      @if (rotaCliente.ultima_visita != null) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Visita</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ rotaCliente.ultima_visita | date: 'dd/MM/yyyy' }} - {{ rotaCliente.qtdeDiasUltVis }} Dias</td>
                                        </tr>
                                      }
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Vendedor(a)</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ rotaCliente.fullname }}</td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="tabela_card_item_quadro p-1">
                              <div class="d-flex flex-column">
                                <div class="text-center">
                                  Mes
                                </div>
                                <div class="d-flex">
                                  <div class="text-right tabela_card_item_valor">
                                    Objetivo
                                    <br />
                                    {{ rotaCliente.objetivo_venda | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Realizado
                                    <br />
                                    {{ rotaCliente.realizado_venda | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Falta Vender
                                    <br />
                                    {{ ((rotaCliente.objetivo_venda || 0) - (rotaCliente.realizado_venda || 0) > 0 ? ((rotaCliente.objetivo_venda || 0) - (rotaCliente.realizado_venda || 0)) : 0) | currency: 'BRL' : '' }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="t"></div>
  </div>
}
